import React, {Fragment} from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import createEditor from "../../form/ComponentEditor";
import Box from "../../layout/Box";
import {
    CurrencyFormatter,
    optionsTemplate,
    UnitFormatter,
    DateFormatter,
    remoteOptionFormatter,
    remoteLanguageFormatter
} from "../../../utils/formatters";
import ContentLoader from "../../layout/ContentLoader";
import Button from "../../form/Button";
import {getComponentConfig, loadComponent} from "../../../utils/components";
import Select from "../../form/Select";
import {get, set} from "../../../utils/dotutils";
import Collapse from "../../layout/Collapse";
import Modal from "../../layout/Modal";
import classNames from "classnames";
import moment from "moment";
import PeriodInput, {periodOptions} from "../../form/PeriodInput";
import RadioGroup from "../../form/RadioGroup";
import TextInput from "../../form/TextInput";
import {stringToDate} from "../../../utils/other";
import SelectorChart from '../../form/SelectorGrid/DataChart';
import Confirm from "../../form/Confirm";
import Icon from "../../form/Icon";
import {isEqual} from "lodash-es";

const formats = [
    {
        key: "day",
        label: "nap"
    },
    {
        key: "month",
        label: "hónap"
    },
    {
        key: "quarter",
        label: "negyed év"
    },
    {
        key: "half",
        label: "fél év"
    },
    {
        key: "year",
        label: "év"
    }
];

export const nameGenerator = (key, field, context) => {
    if (field === "base_product_id") {
        return "Termék";
    } else if (field === "email_confirmed") {
        return "Email megerősítve";
    } else if (field === "product_id" || field === "product") {
        return "Kiadás";
    } else if (field === "productiondate") {
        return "Gyártás dátuma";
    } else if (key === "productperpurchase") {
        return "Áru/Vásárlás";
    } else if (key === "tradename" || key.endsWith(".tradename") || key.endsWith("tradename.name")) {
        return "Kiadó";
    } else if (key === "series" || key === "series.title" || key === "product.series.title") {
        return "Sorozat";
    } else if (key === "manufacturer" || key.endsWith(".manufacturer") || key.endsWith("manufacturer.name")) {
        return "Gyártó";
    } else if (key === "customer" || key.endsWith(".customer") || key.endsWith("customer.name")) {
        return "Vevő";
    } else if (key === "partner" || key.endsWith(".partner") || key.endsWith("partner.name")) {
        return "Partner";
    } else if (key === "pos" || key.endsWith(".pos") || key.endsWith("_pos") || key.endsWith("pos.name")) {
        return "Eladási hely";
    } else if (key === "category.name" || key === "category") {
        return "Árutípus";
    } else if (field === "displayname") {
        return "Megnevezés";
    } else if (field === "sku") {
        return "ISBN";
    } else if (field === "barcode") {
        return "Vonalkód";
    } else if (field === "purchases") {
        return "Vásárlások";
    } else if (field === "authors" || field === "author_id") {
        return "Szerző";
    } else if (field === "id") {
        return "Kód";
    } else if (field === "name") {
        return "Megnevezés";
    } else if (field === "optin" || field === "optin.id") {
        return "OptIn";
    } else if (field === "source") {
        return "Forrás";
    } else if (field === "transaction_month") {
        return "Vásárlás hónapja";
    } else if (field === "signup_month") {
        return "Feliratkozás hónapja";
    } else if (field === "optin_source") {
        return "Feliratkozás forrása";
    } else if (field === "newsletter_id" || field === "newsletter.id" || field === "newsletter") {
        return "Hírlevél";
    } else if (field === "sent") {
        return "Elküldött";
    } else if (field === "opens") {
        return "Nyitások összesen";
    } else if (field === "unique_opens") {
        return "Nyitások";
    } else if (field === "opens_in_24_hours") {
        return "Nyitások 24 órán belül";
    } else if (field === "open_rate") {
        return "Nyitási arány";
    } else if (field === "unsubscribe_rate") {
        return "Leiratkozási arány";
    } else if (field === "unsubscribe") {
        return "Leiratkozások";
    } else if (field === "send_scheduled_at") {
        return "Küldés dátuma";
    } else if (field === "qty") {
        return "Darabszám";
    } else if (field === "discount") {
        return "Kedvezmény";
    } else if (field === "promotion") {
        return "Akció";
    } else if (key === "promotion.name") {
        return "Akció neve";
    } else if (key === "shipping.state") {
        return "Szállítás állapota";
    } else if (key === "shipping.methodname") {
        return "Szállítás módja";
    } else if (key === "shipping.serviceprovider_type") {
        return "Szállítás módja";
    } else if (key === "shipping.location") {
        return "Szállítás célja";
    } else if (key === "shipping.shippingaddress.country") {
        return "Szállítás országa";
    } else if (key === "discount.promo_code") {
        return "Kuponkód";
    } else if (key === "discount.name") {
        return "Kedvezmény neve";
    } else if (key === "discount.value" || key === "disc_value") {
        return "Kedvezmény értéke";
    } else if (key === "discount") {
        return "Kedvezmény";
    } else if (key === "promotion.start_date") {
        return "Akció kezdete";
    } else if (key === "promotion.end_date") {
        return "Akció vége";
    } else if (key === "purchase.agent") {
        return "Vásárló";
    } else if (key === "package_products") {
        return "Csomag tartalma";
    } else if (key === "package_sold") {
        return "Eladott csomagszám";
    } else if (key === "event.program" || key === "event.program.id") {
        return "Program";
    } else if (key === "programtype") {
        return "Program típusa";
    } else if (field === "name") {
        return "Megnevezés";
    } else if (field.indexOf("price") !== -1) {
        let name = "";
        if (field.indexOf("sale") !== -1) {
            name = "Eladási ár";
        } else if (field.indexOf("list") !== -1) {
            name = "Lista ár";
        }
        if (field.indexOf("avg") !== -1) {
            name = "Átlag " + name.toLowerCase();
        }
        if (field.indexOf("net") !== -1) {
            if (field.indexOf("total") !== -1) {
                name = "Nettó " + name.toLowerCase() + " összesen";
            } else {
                name = "Nettó " + name.toLowerCase();
            }
        } else if (field.indexOf("gross") !== -1) {
            if (field.indexOf("total") !== -1) {
                name = "Bruttó " + name.toLowerCase() + " összesen";
            } else {
                name = "Bruttó " + name.toLowerCase();
            }
        }
        return name;
    }
    //return remoteLanguageFormatter("Stat." + context)(key);
    if (context instanceof Function) {
        return context(key);
    } else if (context) {
        if (Array.isArray(context)) {
            let l = key;
            context.map((c) => {
                if (c !== null) {
                    l = remoteLanguageFormatter("Stat." + c)(key, l);
                }
            });
            return l;
        } else {
            return remoteLanguageFormatter("Stat." + context)(key);
        }
    }
    return key;
}

const getDefaultProps = (key, field, context) => {
    let props = {};
    if (key === "pos" || key.endsWith(".pos") || key.endsWith("pos.name") || key == "programtype" || key == "optin_source" || key == "optin" || key == "source") {
        props.storeType = "local";
    } else if (key === "manufacturer" || key.endsWith(".manufacturer") || key.endsWith("manufacturer.name")) {
        props.labelKey = "name";
    } else if (
        key === "customer"
        ||
        key.endsWith(".customer")
        ||
        key.endsWith("customer.name")
        ||
        key === "partner"
        ||
        key.endsWith(".partner")
        ||
        key.endsWith("partner.name")
        ||
        ["customer","seller","partner","partner_id"].indexOf(field) !== -1
    ) {
        props.labelKey = "name";
    }
    return props;
}

export const getColumns = (view, context, prefix = []) => {
    let columns = {};
    Object.entries(view).map((entry) => {
        if (entry[1].constructor === {}.constructor) {
            columns = {...columns, ...getColumns(entry[1], context, [...prefix, entry[0]])};
        } else {
            const key = [...prefix, entry[0]].join(".");
            columns[key] = {
                header: key,
                sortable: true,
                filterable: key.indexOf("partner") !== -1,
                tooltip: (value, rowData) => {
                    return rowData[key.replace(/\./g, '_') + '_tooltip'] || null;
                }
            };
            if (entry[0].indexOf("displayname") !== -1) {
                columns[key].renderer = (value, rowData, rowIndex, props) => {
                    if (!props.isAggregation) {
                        return value;
                    }
                }
            } else if (entry[0].indexOf("points_received") !== -1 || entry[0].indexOf("points_exchanged") !== -1) {
                columns[key].renderer = (value, rowData, rowIndex, props) => {
                    return value + " pont";
                }
                columns[key].width = 1;
            }
            if (entry[0].indexOf("price") !== -1 || ["margin", "points_exchanged_value", "average_points_exchanged_value"].includes(entry[0])) {
                columns[key].renderer = CurrencyFormatter;
                columns[key].aggregation = CurrencyFormatter;
                columns[key].className = "currency";
                /*columns[key].tooltip = (value, rowData, rowIndex, {rows, fieldName}) => {
                    return rowIndex > 0 ? (Math.round(value / rows[rowIndex-1][fieldName] * 10000) / 100) + "%" : "";
                }*/
            }
            if (entry[0].indexOf("qty") !== -1 || entry[0] === "purchases" || key === "productperpurchase") {
                columns[key].renderer = (value, row) => UnitFormatter(value, row?.unit);
                columns[key].aggregation = (value, row) => UnitFormatter(value, row?.unit);
                columns[key].className = "unit";
                columns[key].width = 1;
            }
            if (entry[0].indexOf("discount") !== -1 || entry[0].indexOf("disc_value") !== -1) {
                columns[key].renderer = (value) => {
                    return <span className="percent">{(parseFloat(value || 0) * 100).toFixed(2) + "%"}</span>;
                };
                columns[key].aggregation = (value) => {
                    return <span className="percent">{(parseFloat(value || 0) * 100).toFixed(2) + "%"}</span>;
                };
                columns[key].width = 1;
            }
            if (entry[0].indexOf("loyaltypoint_exchange_value") !== -1) {
                columns[key].renderer = (value) => {
                    return value;
                };
                columns[key].aggregation = (value) => {
                    return value;
                };
                columns[key].width = 1;
            }
            if (entry[0].indexOf("date") !== -1) {
                columns[key].renderer = DateFormatter;
                columns[key].aggregation = DateFormatter;
                columns[key].className = "date";
                columns[key].width = 2;
            }
            if (key.indexOf("discount.value") !== -1) {
                columns[key].renderer = (value, row) => {
                    return (
                        row.discount.calculation_mode == "percentage"
                            ?
                            <span className="percent">{value}%</span>
                            :
                            <span>{value} Ft</span>
                    )
                };
            }
            if (key.indexOf("shipping.state") !== -1) {
                columns[key].renderer = remoteOptionFormatter("shippingstate");
            }

            if (key.indexOf("moneyrepository.component_type") !== -1) {
                columns[key].renderer = remoteLanguageFormatter("MoneyRepositoryType");
            }
            
            if (context === "MoneyTransfer" && entry[0] === "total") {
                columns[key].renderer = CurrencyFormatter;
                columns[key].aggregation = CurrencyFormatter;
                columns[key].className = "currency";
            }

            columns[key].header = nameGenerator(key, entry[0], context) || columns[key].header;

            if (columns[key].renderer === CurrencyFormatter) {
                columns[key].width = 1;
            }
        }
    });
    return columns;
}

const getFieldComponentConfig = async (config, field) => {
    if (typeof config === "string") {
        config = await getComponentConfig(config);
    }
    if (config.fielddefs[field]) {
        return config;
    }
    if (field.indexOf(".") !== -1) {
        const fields = field.split(".", 2);
        if (config.fielddefs[fields[0]]) {
            return getFieldComponentConfig(await getComponentConfig(config.fielddefs[fields[0]].object || config.fielddefs[fields[0]].objects), fields[1]);
        }
    }
    if (config.target) {
        return getFieldComponentConfig(await getComponentConfig(config.target), field);
    } else if (config.objects) {
        return (await Promise.all(config.objects.map(async (object) => {
            return getFieldComponentConfig(await getComponentConfig(object), field);
        }))).find(item => !!item);
    }
}

const HISTORY_REPEAT = 3;
const PAST_REPEAT = 3;

const getDateType = (from, to) => {
    from = moment(from, "YYYY-MM-DD");
    to = moment(to, "YYYY-MM-DD");
    if (from.format("YYYY") === to.format("YYYY")) {
        if (from.format("MM") === to.format("MM")) {
            if (from.format("DD") === to.format("DD")) {
                return "day";
            }
            return "month";
        }
        // https://thisinterestsme.com/php-get-quarter-date/
        if (Math.ceil(from.format("MM") / 3) === Math.ceil(to.format("MM") / 3)) {
            return "quarter";
        }
        const h1 = Math.ceil(from.format("MM") / 3) <= 2 ? 1 : 2;
        const h2 = Math.ceil(to.format("MM") / 3) <= 2 ? 1 : 2;
        if (h1 === h2) {
            return "half";
        }
        return "year";
    }
    return null;
}

class DateFilter extends React.Component {

    constructor(props) {
        super(props);
        this.loadDefaults();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.filterField !== this.props.filterField || this.props.component_name !== prevProps.component_name) {
            this.loadDefaults();
        }
    }

    loadDefaults = () => {
        let settings = this.props.getSettings();
        const defaults = this.props.defaults || {};
        const defaultDate = moment().format("YYYY-MM-DD");
        const field = defaults.field || get(settings, "field", this.props.filterConfig.types[this.props.filterConfig.default || 0]);
        let value = get(settings, "value") || defaults.value || [defaultDate, defaultDate];
        if (value && !Array.isArray(value)) {
            value = [value, value];
        }
        value = value.map((v) => typeof v === "string" ? moment(stringToDate(v)).format("YYYY-MM-DD") : v);
        const by = defaults.by || get(settings, "by") || "history";
        const history_repeat = defaults.history_repeat || get(settings, "history_repeat") || HISTORY_REPEAT;
        const past_repeat = defaults.past_repeat || get(settings, "past_repeat") || PAST_REPEAT;
        let other_dates = defaults.other_dates || get(settings, "other_dates") || null;
        if (Array.isArray(other_dates)) {
            other_dates = other_dates.map((dates) => dates.map((v) => typeof v === "string" ? moment(stringToDate(v)).format("YYYY-MM-DD") : v));
        }
        settings = {...settings, field, value, by, history_repeat, past_repeat, other_dates};
        this.setSettings(this.props.setSettings(settings));
    }

    setSettings = (settings) => {
        const field = get(settings, "field", this.props.filterConfig.types[this.props.filterConfig.default || 0]);
        const value = get(settings, "value") || [];
        const by = get(settings, "by") || "history";
        const compare = get(settings, "compare") || false;
        let groupField = null;
        if (compare) {
            if (by === "history") {
                groupField = field + "_year";
            } else if (by === "past") {
                const {selected, periods} = periodOptions(value[0].substr(0, 4), value[0], value[1]);
                const type = getDateType(value[0], value[1]);
                if (type === "year") {
                    groupField = field + "_year";
                } else if (type !== "day") {
                    groupField = field + "_year_" + type;
                } else {
                    groupField = field + "_date";
                }
            } else if (by === "other") {
                groupField = field + "_group";
            }
        }
        this.props.setFieldValue("groupField", groupField);
    }

    setFieldSettings = (field, value) => {
        this.setSettings(this.props.setSettings(value, field));
    }

    render() {
        let settings = this.props.getSettings();
        if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
            return null;
        }
        settings = settings || {};
        const history_repeat = get(settings, "history_repeat") || HISTORY_REPEAT;
        const past_repeat = get(settings, "past_repeat") || PAST_REPEAT;
        const value = get(settings, "value") || [];
        const from = moment(value[0], "YYYY-MM-DD");
        const to = moment(value[1], "YYYY-MM-DD");
        let other_dates = get(settings, "other_dates") || [];
        const defaultOtherDate = [from.year(from.format("YYYY") - 1).format("YYYY-MM-DD"), to.year(to.format("YYYY") - 1).format("YYYY-MM-DD")];
        const {selected, periods} = periodOptions((value[0] || (new Date()).getFullYear() + "").substr(0, 4), value[0], value[1]);
        const selectedPeriod = periods.find((period) => period.key === selected);
        return <div className="col-md-12">
            <div className="form-group">
                <div className="row">
                    <div className={classNames({"col-md-9": this.props.filterConfig.types.length > 1, "col-md-11": this.props.filterConfig.types.length <= 1})}>
                        <PeriodInput
                            year={true}
                            value={(get(settings, "value") || [])}
                            label="Dátum"
                            saveChanges={(field, value) => {
                                if (!value[0]) {
                                    this.setFieldSettings("value", null);
                                } else {
                                    if (!value[1]) {
                                        value[1] = value[0];
                                    }
                                    this.setFieldSettings("value", value);
                                }
                            }}
                        />
                    </div>
                    {this.props.filterConfig.types.length > 1 && <div className="col-md-2">
                        <div className="form-group">
                            <Select
                                storeType="local"
                                label="Dátum mező"
                                objectValue={false}
                                options={this.props.filterConfig.types.map((field) => ({field, label: ((field) => {
                                        switch (field) {
                                            case "created_at": return "Rögzítés időpontja";
                                            case "transaction_date": return "Tranzakciós dátum";
                                            case "send_scheduled_at": return "Küldés dátuma";
                                            case "event_at": return "Esemény időpontja";
                                            case "optin_subscription_date": return "Feliratkozás dátuma";
                                            case "optin_unsubscription_date": return "Leiratkozás dátuma";
                                            case "signup_date": return "Feliratkozás dátuma";
                                        }
                                    })(field)}))}
                                {...this.props.filterConfig}
                                valueKey="field"
                                labelKey="label"
                                value={get(settings, "field", this.props.filterConfig.types[this.props.filterConfig.default || 0])}
                                saveChanges={(f, field) => {
                                    this.setFieldSettings("field", field);
                                }}
                            />
                        </div>
                    </div>}
                    <div className="col-md-1">
                        <div className="form-group">
                            <label className="control-label">&nbsp;</label>
                            <Button
                                block={true}
                                color={settings.compare ? "primary" : "default"}
                                tooltip="Összehasonlítás"
                                icon={{lib: "fas", name: "chart-bar"}}
                                onClick={() => this.setFieldSettings("compare", !settings.compare)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Collapse collapsed={!!settings.compare}>
                <div>
                    <div className="row">
                        {get(settings, "by") === "history" && <div className="col-md-2">
                            <div className="form-group">
                                <TextInput
                                    type="number"
                                    label={"Az elmúlt " + (history_repeat || "x") + " év"}
                                    value={(get(settings, "history_repeat") || null)}
                                    saveChanges={(field, history_repeat) => {
                                        this.setFieldSettings("history_repeat", history_repeat);
                                    }}
                                />
                            </div>
                        </div>}
                        {get(settings, "by") === "past" && <div className="col-md-2">
                            <div className="form-group">
                                <TextInput
                                    type="number"
                                    label={"Előző " + past_repeat + " " + ((formats.find((f) => (selectedPeriod || {}).type === f.key) || {}).label || "nap")}
                                    value={(get(settings, "past_repeat") || null)}
                                    saveChanges={(field, past_repeat) => {
                                        this.setFieldSettings("past_repeat", past_repeat);
                                    }}
                                />
                            </div>
                        </div>}
                        <div className="col-md-6">
                            <div className="form-group">
                                <RadioGroup
                                    objectValue={false}
                                    options={[
                                        {
                                            key: "history",
                                            label: "Éves bontás"
                                        },
                                        {
                                            key: "past",
                                            label: "Előző időszak"
                                        },
                                        {
                                            key: "other",
                                            label: "Szabadon választott"
                                        }
                                    ]}
                                    valueKey="key"
                                    labelKey="label"
                                    value={(get(settings, "by") || "history")}
                                    saveChanges={(field, by) => {
                                        this.setFieldSettings("by", by);
                                    }}
                                    label="Összehasonlítás alapja"
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            {get(settings, "by") === "other" && <div>{
                                other_dates.find((date) => {
                                    date = date || defaultOtherDate;
                                    return moment(date[0], "YYYY-MM-DD").diff(moment(date[1], "YYYY-MM-DD"), 'days') !== moment(value[0], "YYYY-MM-DD").diff(moment(value[1], "YYYY-MM-DD"), 'days');
                                }) ? <div className="label label-danger">Eltérő időszakokat hasonlítasz össze!</div> : null
                            }</div>}
                        </div>
                    </div>
                    {get(settings, "by") === "other" && <Fragment>
                        {other_dates.map((date, idx) => {
                            return <div key={idx} className="row">
                                <div className="col-md-11">
                                    <div className="form-group">
                                        <PeriodInput
                                            year={true}
                                            value={date || defaultOtherDate}
                                            label="Dátum"
                                            saveChanges={(field, value) => {
                                                const new_dates = [...other_dates];
                                                if (!value[0]) {
                                                    new_dates[idx] = null;
                                                } else {
                                                    if (!value[1]) {
                                                        value[1] = value[0];
                                                    }
                                                    new_dates[idx] = value;
                                                }
                                                this.setFieldSettings("other_dates", new_dates);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <div className="form-group">
                                        <label className="control-label">&nbsp;</label>
                                        <Button
                                            icon={{lib: "fa", name: "times"}}
                                            color="danger"
                                            block={true}
                                            onClick={() => {
                                                const new_dates = [...other_dates];
                                                new_dates.splice(idx, 1);
                                                this.setFieldSettings("other_dates", new_dates);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>;
                        })}
                        <div className="form-group">
                            <Button
                                color="default"
                                block={true}
                                icon={{lib: "fas", name: "plus"}}
                                onClick={() => this.setFieldSettings("other_dates", [...other_dates, defaultOtherDate])}
                                tooltip="További dátumok hozzáadása"
                            />
                        </div>
                    </Fragment>}
                </div>
            </Collapse>
        </div>;
    }
}

export class PosFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            options: [],
            isLoading: true
        }
        this.loadDefaults();
        this.loadOptions(false);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.filterField !== this.props.filterField || this.props.component_name !== prevProps.component_name) {
            this.loadDefaults();
            this.loadOptions();
        }
    }

    loadOptions = (state = true) => {
        const c = () => {
            let load = 2;
            this.pointOfSalesRequest && this.pointOfSalesRequest.abort();
            this.pointOfSalesRequest = loadComponent("componentlist", {
                component: "PointOfSale",
                itemsperpage: 0,
                view: ["id","name"],
            });
            this.pointOfSalesRequest.then((list) => {
                load--;
                this.setState({options: [...this.state.options, ...list.items.map((pos) => ({...pos, id: "pos|" + pos.id, type: "pos"}))].sort((a,b) => a.id.indexOf("group|")-b.id.indexOf("group|")), isLoading: !!load});
            });
            this.pointOfSalesGroupsRequest && this.pointOfSalesGroupsRequest.abort();
            this.pointOfSalesGroupsRequest = loadComponent("componentlist", {
                component: "PointOfSaleGroup",
                itemsperpage: 0,
                view: ["id","name"],
            });
            this.pointOfSalesGroupsRequest.then((list) => {
                load--;
                this.setState({options: [...this.state.options, ...list.items.map((pos) => ({...pos, id: "group|" + pos.id, type: "group"}))].sort((a,b) => a.id.indexOf("group|")-b.id.indexOf("group|")), isLoading: !!load});
            });
        }
        if (state) {
            this.setState({options: [], isLoading: true}, () => {
                c();
            });
        } else {
            c();
        }
    }

    loadDefaults = () => {
        let settings = this.props.getSettings();
        const defaults = this.props.defaults || {};
        const value = get(settings, "value") || defaults.value || null;
        settings = {...settings, value};
        this.props.setSettings(settings);
    }

    setFieldSettings = (field, value) => {
        this.props.setSettings(value, field);
    }

    render() {
        const filterField = this.props.getFilterField();
        const field = filterField.split(".");
        const currentField = field.pop();
        const settings = this.props.getSettings();
        let value = get(settings, "value");
        return (
            <div className={this.props.colWidthClass || "col-md-3"}>
                <div className="form-group">
                    <Select
                        storeType="local"
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        objectValue={false}
                        isClearable={true}
                        isMulti={true}
                        optionsTemplate={(data) => {
                            if (data.id.indexOf("group|") === 0) {
                                return <b><i>{data.name}</i></b>;
                            } else {
                                return data.name;
                            }
                        }}
                        isLoading={this.state.isLoading}
                        options={this.state.options}
                        {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                        required={this.props.filterConfig.required}
                        {...(this.props.filterConfig.props || {})}
                        valueKey="id"
                        labelKey="name"
                        value={value}
                        saveChanges={(f, value) => {
                            let values = value;
                            if (values.length) {
                                values = values.sort();
                            } else {
                                values = null;
                            }
                            this.setFieldSettings("value", values)
                        }}
                    />
                </div>
            </div>
        );
    }
}

export class Filter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            config: null,
            fieldConfig: null
        }
        this.loadConfig();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.filterField !== this.props.filterField || this.props.component_name !== prevProps.component_name) {
            this.loadConfig();
        }
    }

    loadConfig = () => {
        this.abort && this.abort();
        let aborted = false;
        this.abort = () => {
            aborted = true;
        }
        this.state.config && this.setState({config: null});
        getFieldComponentConfig(this.props.component_name, this.props.filterField).then((config) => {
            if (!aborted) {
                this.setState({config: false}, () => {
                    if (config) {
                        const field = this.props.filterField.split(".");
                        const currentField = field.pop();
                        const fieldComponent = config.fielddefs[currentField] && (config.fielddefs[currentField].object || config.fielddefs[currentField].objects);
                        if (fieldComponent) {
                            getComponentConfig(fieldComponent).then((fieldConfig) => {
                                if (!aborted) {
                                    this.setState({fieldConfig}, () => this.loadDefaults());
                                }
                            })
                        } else {
                            this.loadDefaults();
                        }
                    } else {
                        this.loadDefaults();
                    }
                });
            }
        })
    }

    loadDefaults = () => {
        if (this.state.fieldConfig && this.state.fieldConfig.componentname !== "PointOfSale" && this.props.defaults) {
            const settings = this.getSettings() || {};
            const defaults = this.props.defaults || {};
            settings.value = defaults.value || get(settings, "value");
            if (settings.value && !Array.isArray(settings.value)) {
                settings.value = [settings.value];
            }
            this.setSettings(settings);
        }
    }

    getSettings = () => {
        return get(this.props.values, "parameters");
    }

    setSettings = (value, field = null) => {
        let settings = this.getSettings() || {};
        if (field) {
            set(settings, field, value);
            this.props.setFieldValue("parameters." + field, value);
        } else {
            settings = value;
            this.props.setFieldValue("parameters", value);
        }
        if(this.props.filterConfig.fieldtype === "Date") {
            return settings;
        }
    }

    getFilterField = () => {
        return this.props.filterField;
    }

    render() {
        if (this.state.config === null) return null;
        const filterField = this.getFilterField();
        const field = filterField.split(".");
        const currentField = field.pop();
        const settings = this.getSettings();
        const colWidthClass = this.props.colWidthClass || "col-md-3";
        if (filterField === "purchase.agent") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        storeType="local"
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        objectValue={false}
                        labelKey="label"
                        {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                        required={this.props.filterConfig.required}
                        {...(this.props.filterConfig.props || {})}
                        valueKey="value"
                        value={get(settings, "type") || "all"}
                        options={[
                            {
                                label: "Összes",
                                value: "all"
                            },
                            {
                                label: "Törzsvásárlói vásárlás",
                                value: "customer"
                            },
                            {
                                label: "Egyéb vásárlás",
                                value: "other"
                            }
                        ]}
                        saveChanges={(f, value) => {
                            this.setSettings(value, "type");
                            if (value === "customer") {
                                this.setSettings(null, "value");
                                this.setSettings("not isnull", "operator");
                            } else if (value === "other") {
                                this.setSettings(null, "value");
                                this.setSettings("isnull", "operator");
                            } else {
                                this.setSettings(undefined, "value");
                                this.setSettings(undefined, "operator");
                            }
                        }}
                    />
                </div>
            </div>;
        }
        if (this.state.fieldConfig) {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            if (this.state.fieldConfig.componentname === "PointOfSale") {
                return <PosFilter
                    {...this.props}
                    fieldConfig={this.state.fieldConfig}
                    setSettings={this.setSettings}
                    getSettings={this.getSettings}
                    getFilterField={this.getFilterField}
                    colWidthClass={colWidthClass}
                />;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        storeType="remote"
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        objectValue={false}
                        isClearable={true}
                        isMulti={true}
                        optionsTemplate={optionsTemplate(this.state.fieldConfig.componentname)}
                        component={this.state.fieldConfig.componentname}
                        valueKey={this.state.fieldConfig.idfield}
                        {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                        required={this.props.filterConfig.required}
                        {...(this.props.filterConfig.props || {})}
                        value={get(settings, "value")}
                        saveChanges={(f, value) => {
                            this.setSettings(value.length ? value : undefined, "value");
                        }}
                    />
                </div>
            </div>;
        } else if (this.props.filterConfig.fieldtype === "DateString") {
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        optionname="DateString"
                        objectValue={false}
                        storeType="local"
                        {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                        label={
                            nameGenerator(filterField, filterField, [this.props.componentId, this.props.baseComponentId])
                            || filterField
                        }
                        value={get(settings, "value")}
                        saveChanges={(f, value) => {
                            this.setSettings(value.length ? value : undefined, "value");
                        }}
                    />
                </div>
            </div>;
        } else if (this.props.filterConfig.fieldtype === "Date") {
            return (
                <DateFilter
                    {...this.props}
                    setSettings={this.setSettings}
                    getSettings={this.getSettings}
                    getFilterField={this.getFilterField}
                />
            );
        } else if (currentField === "product_id" || currentField === "base_product_id") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        storeType="remote"
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        objectValue={false}
                        isClearable={true}
                        isMulti={true}
                        optionsTemplate={optionsTemplate("product")}
                        component="product"
                        {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                        required={this.props.filterConfig.required}
                        {...(this.props.filterConfig.props || {})}
                        valueKey={currentField === "base_product_id" ? "base_product_id" : "id"}
                        value={get(settings, "value")}
                        saveChanges={(f, value) => {
                            this.setSettings(value.length ? value : undefined, "value");
                        }}
                    />
                </div>
            </div>;
        } else if (currentField === "disc_direction") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        storeType="local"
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        objectValue={false}
                        labelKey="label"
                        {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                        required={this.props.filterConfig.required}
                        {...(this.props.filterConfig.props || {})}
                        valueKey="value"
                        value={get(settings, "type") || "all"}
                        options={[
                            {
                                label: "Teljes lista",
                                value: "all"
                            },
                            {
                                label: "Feltétel",
                                value: "condition"
                            },
                            {
                                label: "Cél",
                                value: "target"
                            }
                        ]}
                        saveChanges={(f, value) => {
                            this.setSettings(value, "type");
                            if (value === "condition") {
                                this.setSettings("condition", "value");
                            } else if (value === "target") {
                                this.setSettings("target", "value");
                            } else {
                                this.setSettings(undefined, "value");
                                this.setSettings(undefined, "operator");
                            }
                        }}
                    />
                </div>
            </div>;
        } else if (currentField === "author_id") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        storeType="remote"
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        objectValue={false}
                        isClearable={true}
                        isMulti={true}
                        optionsTemplate={optionsTemplate("author")}
                        component="author"
                        {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                        required={this.props.filterConfig.required}
                        {...(this.props.filterConfig.props || {})}
                        value={get(settings, "value")}
                        saveChanges={(f, value) => {
                            this.setSettings(value.length ? value : undefined, "value");
                        }}
                    />
                </div>
            </div>;
        } else if (currentField === "state") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        optionname="shippingstate"
                        isMulti={true}
                        storeType="local"
                        isClearable={true}
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        value={get(settings, "value")}
                        objectValue={false}
                        saveChanges={(f, value) => {
                            this.setSettings(value.length ? value : undefined, "value");
                        }}
                    />
                </div>
            </div>;
        } else if (currentField === "serviceprovider_type") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        optionname="shippingprovider"
                        isMulti={true}
                        storeType="local"
                        isClearable={true}
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        value={get(settings, "value")}
                        objectValue={false}
                        saveChanges={(f, value) => {
                            this.setSettings(value.length ? value : undefined, "value");
                        }}
                    />
                </div>
            </div>;
        } else if (currentField === "newsletter_id" || currentField === "newsletter") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        storeType="remote"
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        objectValue={false}
                        isClearable={true}
                        isMulti={true}
                        component="Newsletter"
                        {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                        required={this.props.filterConfig.required}
                        {...(this.props.filterConfig.props || {})}
                        valueKey="id"
                        value={get(settings, "value")}
                        saveChanges={(f, value) => {
                            this.setSettings(value.length ? value : undefined, "value");
                        }}
                    />
                </div>
            </div>;
        } else if (currentField === "country") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        storeType="remote"
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        objectValue={false}
                        isClearable={true}
                        isMulti={true}
                        component="country"
                        labelKey="name"
                        {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                        required={this.props.filterConfig.required}
                        {...(this.props.filterConfig.props || {})}
                        valueKey="id"
                        value={get(settings, "value")}
                        saveChanges={(f, value) => {
                            this.setSettings(value.length ? value : undefined, "value");
                        }}
                    />
                </div>
            </div>;
        } else if (currentField === "reason") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        optionname="UnsubscribeReason"
                        isMulti={true}
                        storeType="local"
                        isClearable={true}
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        value={get(settings, "value")}
                        objectValue={false}
                        saveChanges={(f, value) => {
                            this.setSettings(value.length ? value : undefined, "value");
                        }}
                    />
                </div>
            </div>;
        } else if (currentField === "email_confirmed") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        isMulti={false}
                        storeType="local"
                        isClearable={true}
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        value={get(settings, "value")}
                        objectValue={false}
                        valueKey="id"
                        labelKey="name"
                        options={[
                            {id: 1, name: "Megerősítve"},
                            {id: 0, name: "Nincs megerősítve"},
                        ]}
                        saveChanges={(f, value) => {
                            this.setSettings(value, "value");
                        }}
                    />
                </div>
            </div>;
        } else if (currentField === "postcode") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            let operator = settings?.operator || "LIKE";
            let value = settings?.value;
            let from = undefined;
            let to = undefined;
            if (!Array.isArray(value) && value) {
                if (operator === "<") {
                    to = value;
                    value = [null, value];
                } else if (operator === ">") {
                    from = value;
                    value = [value, null];
                }
            } else if (Array.isArray(value)) {
                from = value[0];
                to = value[1];
            }
            const saveChange = (value) => {
                if (value[0] && value[1]) {
                    operator = "between";
                } else if (value[1]) {
                    operator = "<";
                    value = value[1];
                } else if (value[0]) {
                    operator = ">";
                    value = value[0];
                } else {
                    value = null;
                }
                if (value) {
                    this.setSettings({value, operator});
                } else {
                    this.setSettings(null);
                }
            }
            return <div className={colWidthClass}>
                <label className="control-label">
                    <span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                        icon={{lib: "fa", name: "times"}}
                        color="danger"
                        size="xs"
                        className="pull-right label-button"
                        onClick={() => {
                            this.props.setFieldValue("parameters", null);
                            this.props.setFieldValue("filter", null);
                        }}
                    />}</span>
                    {this.props.filterConfig.required && <span className="invalid-feedback">*</span>}
                </label>
                <div className="row">
                    <div className="col-md-6">
                        <TextInput
                            {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                            type="number"
                            placeholder="Tól"
                            label={false}
                            value={from}
                            saveChanges={(field, c) => {
                                value = !Array.isArray(value) ? [c, null] : value;
                                value[0] = c;
                                saveChange(value);
                            }}
                        />
                    </div>
                    <div className="col-md-6">
                        <TextInput
                            {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                            type="number"
                            placeholder="Ig"
                            label={false}
                            value={to}
                            saveChanges={(field, c) => {
                                value = !Array.isArray(value) ? [null, c] : value;
                                value[1] = c;
                                saveChange(value);
                            }}
                        />
                    </div>
                </div>
            </div>;
        } else if (currentField === "age_recommendation") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            let operator = settings?.operator || "=";
            let value = get(settings, "value");
            if (operator === "in") {
                value = value.join(",");
            } else if (operator === "between") {
                value = value[0] + "-" + value[1];
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <TextInput
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                        required={this.props.filterConfig.required}
                        {...(this.props.filterConfig.props || {})}
                        value={value}
                        saveChanges={(f, value) => {
                            let operator = "=";
                            if (value.indexOf("-") !== -1) {
                                value = value.trim().split("-").map((v) => v.trim()).filter((v) => !isNaN(v));
                                if (!isNaN(value[0]) && !isNaN(value[1])) {
                                    value = [value[0], value[1]];
                                    operator = "between";
                                } else {
                                    value = undefined;
                                }
                            } else if (value.indexOf(",") !== -1) {
                                value = value.trim().split(",").map((v) => v.trim()).filter((v) => !isNaN(v));
                                operator = "in";
                            }
                            if (value) {
                                this.setSettings({value, operator});
                            } else {
                                this.setSettings(null);
                            }
                        }}
                    />
                </div>
            </div>;
        } else if (currentField === "customer_is_registered") {
            if (!(settings || this.props.filterConfig.required || this.props.filterConfig.visible)) {
                return null;
            }
            return <div className={colWidthClass}>
                <div className="form-group">
                    <Select
                        storeType="local"
                        label={<span className="stat-label">{nameGenerator(filterField, currentField, [this.props.componentId, this.props.baseComponentId]) || filterField} {!(this.props.filterConfig.required || this.props.filterConfig.visible) && <Button
                            icon={{lib: "fa", name: "times"}}
                            color="danger"
                            size="xs"
                            className="pull-right label-button"
                            onClick={() => {
                                this.props.setFieldValue("parameters", null);
                                this.props.setFieldValue("filter", null);
                            }}
                        />}</span>}
                        objectValue={false}
                        isClearable={true}
                        optionname="customer_is_registered"
                        {...getDefaultProps(filterField, currentField, [this.props.componentId, this.props.baseComponentId])}
                        required={this.props.filterConfig.required}
                        {...(this.props.filterConfig.props || {})}
                        value={get(settings, "value")}
                        saveChanges={(f, value) => {
                            this.setSettings(value.length ? value : undefined, "value");
                        }}
                    />
                </div>
            </div>;
        }
        return null;
    }
}

class Filters extends React.Component {

    state = {
        addMoreFilter: []
    }

    render() {
        const filters = this.props.filters || {};
        let addMore = [];
        return (
            <Fragment>
                <div className="row">
                    {Object.entries(filters).sort((a,b) => {
                        if ((a[1].required || a[1].visible) && (b[1].required || b[1].visible)) {
                            return a[1].sort - b[1].sort;
                        }
                        if (!(a[1].required || a[1].visible) && !(b[1].required || b[1].visible)) {
                            return b[1].sort - a[1].sort;
                        }
                        if ((a[1].required || a[1].visible) && !(b[1].required || b[1].visible)) {
                            return -1;
                        }
                        if(!(a[1].required || a[1].visible) && (b[1].required || b[1].visible)) {
                            return 1;
                        }
                        return 0;
                    }).map((entry, idx) => {
                        const key = entry[0].replace(/\./g, "/");
                        const filterConfig = entry[1];
                        if (!(get(this.props.settings, "filters." + key + ".parameters") || filterConfig.required || filterConfig.visible)) {
                            addMore.push(key);
                        }
                        return <Filter
                            key={idx}
                            {...this.props}
                            filterField={entry[0]}
                            filterConfig={filterConfig}
                            defaults={(this.props.values.default_filters || {})[entry[0]]}
                            values={get(this.props.settings, "filters." + key)}
                            componentId={this.props.values[this.props.componentConfig.idfield]}
                            baseComponentId={this.props.values.base_stat}
                            setFieldValue={(field, value) => {
                                this.props.setFieldValue("filters." + key + "." + field, value);
                            }}
                        />;
                    })}
                    <div className="col-md-1">
                        {!!addMore.length && <div className="form-group">
                            <label className="control-label">&nbsp;</label>
                            <Confirm
                                header="További lehetséges szűrők"
                                size="medium"
                                body={<div className="more-filter">
                                    {addMore.map((key, idx) => {
                                        return <Button
                                            key={idx}
                                            color={this.state.addMoreFilter.indexOf(key) !== -1 ? "primary" : "default"}
                                            onClick={() => this.setState({addMoreFilter: this.state.addMoreFilter.indexOf(key) !== -1 ? [...this.state.addMoreFilter].filter((k) => k !== key) : [...this.state.addMoreFilter, key]})}
                                        >
                                            {nameGenerator(key.replace(/\//g, "."), key.replace(/\//g, ".").split(".").pop(), [this.props.values[this.props.componentConfig.idfield], this.props.values.base_stat])}
                                        </Button>;
                                    })}
                                </div>}
                                acceptAble={!!this.state.addMoreFilter.length}
                                onAccept={() => {
                                    this.state.addMoreFilter.map((key) => {
                                        set(this.props.settings, "filters." + key + ".parameters", {});
                                        this.props.setFieldValue("filters", this.props.settings.filters);
                                    });
                                    this.setState({addMoreFilter: []});
                                }}
                                onCancel={() => {
                                    this.setState({addMoreFilter: []});
                                }}
                            >
                                <Button
                                    color="default"
                                    block={true}
                                    icon={{lib: "fas", name: "plus"}}
                                    tooltip="További lehetséges szűrők"
                                />
                            </Confirm>
                        </div>}
                    </div>
                </div>
            </Fragment>
        );
    }
}

class Dimensions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            base_dimensions: this.props.base_dimensions,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            !isEqual(this.props?.base_dimensions, prevProps?.base_dimensions)
        ) {
            this.setState({
                base_dimensions: this.props.base_dimensions,
            });
        }
    }

    render() {
        let addMore = [];
        return (
            <div className="dimensions">
                <label className="control-label">Csoportosítás</label>
                <div className="form-group">
                    {Object.keys(this.props.statSettings.dimensions).sort((a, b) => this.props.statSettings.base_dimension.indexOf(b) - this.props.statSettings.base_dimension.indexOf(a)).map((dimension, idx) => {
                        const fix = this.props.statSettings.base_dimension.indexOf(dimension) !== -1;
                        const selected = this.props.base_dimensions.indexOf(dimension) !== -1;
                        if (fix || selected) {
                            return <Button
                                key={idx}
                                color="primary"
                                icon={fix ? {lib: "fa", name: "lock"} : null}
                                onClick={() => {
                                    if (!fix) {
                                        const dimensions = [...this.state.base_dimensions];
                                        if (selected) {
                                            dimensions.splice(dimensions.indexOf(dimension), 1);
                                        } else {
                                            dimensions.push(dimension);
                                        }
                                        this.props.onChange && this.props.onChange(dimensions);
                                    }
                                }}
                            >
                                {nameGenerator(dimension, dimension, [this.props.values[this.props.componentConfig.idfield], this.props.values.base_stat])}
                            </Button>;
                        } else {
                            addMore.push(dimension);
                        }
                    })}
                    {!!addMore.length && <Confirm
                        header="További lehetséges csoportosítások"
                        size="medium"
                        color="primary"
                        acceptAble={JSON.stringify(this.state.base_dimensions.sort()) !== JSON.stringify(this.props.base_dimensions.sort())}
                        body={<div className="more-dimension">
                            {addMore.map((dimension, idx) => {
                                const selected = this.state.base_dimensions.indexOf(dimension) !== -1;
                                return <Button
                                    key={idx}
                                    color={selected ? "primary" : "default"}
                                    onClick={() => {
                                        const dimensions = [...this.state.base_dimensions];
                                        if (selected) {
                                            dimensions.splice(dimensions.indexOf(dimension), 1);
                                        } else {
                                            dimensions.push(dimension);
                                        }
                                        this.setState({base_dimensions: dimensions});
                                    }}
                                >
                                    {nameGenerator(dimension, dimension, [this.props.values[this.props.componentConfig.idfield], this.props.values.base_stat])}
                                </Button>
                            })}
                        </div>}
                        onAccept={() => {
                            const dimensions = [...this.state.base_dimensions];
                            this.props.onChange && this.props.onChange(dimensions);
                        }}
                        onCancel={() => {
                            this.setState({
                                base_dimensions: this.props.base_dimensions,
                            });
                        }}
                    >
                        <Button color="default" icon={{lib: "fa", name: "plus"}} tooltip="További lehetséges csoportosítások" />
                    </Confirm>}
                </div>
            </div>
        );
    }
}

class StatisticsTab extends React.Component {

    getFilters = () => {
        let required = false;
        const filters = this.getPossibleFilters();
        const filtersValues = get(this.props.settings, "filters") || {};
        const search = Object.entries(filters).map((entry, idx) => {
            const values = filtersValues[entry[0].replace(/\./g, "/")] || {};
            return {groupField: values.groupField};
        }).filter((v) => !!v).reduce((all, current) => {
            return {
                groupField: all.groupField || current.groupField
            };
        }, {});
        const parameters = {};
        Object.entries(filtersValues).map((entry) => {
            parameters[entry[0].replace(/\//g, ".")] = entry[1].parameters;
        });
        search.parameters = parameters;
        if (!required) {
            return search;
        }
        return null;
    }

    getStatSettings = () => {
        return this.props.values;
    }

    getPossibleFilters = () => {
        return this.getStatSettings().filters || {};
    }

    getFieldValue = (key, def = null) => {
        if (key) {
            return get(this.props.settings, key) || def;
        } else {
            return this.props.settings;
        }
    }

    setFieldValue = (key, value) => {
        this.props.setFieldValue(key, value);
    }

    render() {

        const newFilter = this.getFilters();
        const currentFilter = this.getFieldValue("currentFilter");
        const newDimensions = this.getFieldValue("dimensions", []);
        const currentDimensions = this.getFieldValue("currentDimensions", []);
        const same = (JSON.stringify(currentFilter) === JSON.stringify(newFilter) || newFilter === null) && JSON.stringify(currentDimensions) === JSON.stringify(newDimensions);

        const statSettings = this.getStatSettings();
        const columns = getColumns(statSettings.base_view, statSettings[this.props.componentConfig.idfield]);
        const search = JSON.parse(JSON.stringify(currentFilter));
        let parameters = null;
        let visibleColumns = Object.keys(getColumns(statSettings.stat_view));
        const newVisibleColumns = this.getFieldValue("visibleColumns", []);
        // TODO ez a length dolog nem kéne ide... De Péterrel azt beszéltük hogy annyi oszlopot amennyi az alap dimenzió annyit előre pakolunk.
        let sort = [...Object.keys(columns).slice(0, statSettings.base_dimension.length), ...statSettings.base_dimension];
        Object.keys(statSettings.dimensions).map((key) => {
            if (statSettings.dimensions[key].fields) {
                statSettings.dimensions[key].fields.map((key) => {
                    sort.push(key);
                });
            } else {
                sort.push(key);
            }
        });
        let currentVisibleColumns = this.getFieldValue("currentVisibleColumns", []);
        sort = [...sort, ...currentVisibleColumns, ...visibleColumns];
        currentVisibleColumns = [...currentVisibleColumns, ...visibleColumns].sort((a, b) => {
            if (sort.indexOf(b) > sort.indexOf(a)) return -1;
            if (sort.indexOf(b) < sort.indexOf(a)) return 1;
            return 0;
        });

        if (search) {
            parameters = search.parameters;
            delete search.parameters;
            delete search.filter;
        }

        return <div className="statistics">
            <div className="row">
                <div className="col-md-12">
                    <Dimensions
                        {...this.props}
                        component_name={this.props.values.component_name}
                        base_dimensions={newDimensions}
                        settings={this.props.settings}
                        statSettings={statSettings}
                        onChange={(dimensions) => {
                            let newVisibleColumns = [];
                            const filters = this.getFieldValue().filters;
                            dimensions.map((key) => {
                                if (statSettings.dimensions[key].filters) {
                                    statSettings.dimensions[key].filters.map((key) => {
                                        set(filters, (key.replace(/\./g, "/")) + ".parameters", get(filters, (key.replace(/\./g, "/")) + ".parameters") || {});
                                    });
                                } else {
                                    set(filters, (key.replace(/\./g, "/")) + ".parameters", get(filters, (key.replace(/\./g, "/")) + ".parameters") || {});
                                }
                                if (statSettings.dimensions[key].fields) {
                                    statSettings.dimensions[key].fields.map((key) => {
                                        newVisibleColumns.push(key);
                                    });
                                } else {
                                    newVisibleColumns.push(key);
                                }
                            });
                            this.setFieldValue("filters", filters);
                            this.setFieldValue("dimensions", dimensions);
                            this.setFieldValue("visibleColumns", newVisibleColumns);
                        }}
                    />
                </div>
                <div className="col-md-12">
                    <Filters
                        {...this.props}
                        component_name={this.props.values.component_name}
                        filters={this.getPossibleFilters()}
                        settings={this.props.settings}
                        statSettings={statSettings}
                    />

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <Button
                                    color={same ? "default" : "warning"}
                                    disabled={same}
                                    block={true}
                                    icon={{lib: "fa", name: "search"}}
                                    onClick={() => {
                                        this.setFieldValue("currentFilter", newFilter);
                                        this.setFieldValue("currentDimensions", newDimensions);
                                        this.setFieldValue("currentVisibleColumns", newVisibleColumns);
                                    }}
                                    tooltip="Szűrés"
                                />
                            </div>
                        </div>
                    </div>

                </div>
                <div className="col-md-12">
                    {search && <SelectorGrid
                        gridid={this.props.componentEditor}
                        option={this.props.componentConfig.componentname}
                        component={this.props.componentConfig.componentname}
                        exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", addFilters: true}]}
                        aggregations={statSettings.aggregation_fields ? {
                            fields: statSettings.aggregation_fields
                        } : null}
                        reqparams={{
                            stat: true,
                            id: statSettings[this.props.componentConfig.idfield],
                            filters: parameters,
                            base_dimensions: currentDimensions,
                        }}
                        columns={columns}
                        columnSort={currentVisibleColumns}
                        {...search}
                        visibleColumns={currentVisibleColumns}
                        rowGroupHeaderTemplate={search.groupField ? (row) => get(row, search.groupField) : null}
                        rowGroupFooterTemplate={() => {}}
                        pageSize={statSettings.limit || (statSettings.presets && statSettings.presets.itemsperpage) || undefined}
                        orderBy={
                            statSettings.presets && statSettings.presets.order ?
                                {
                                    field: statSettings.presets.order.field || statSettings.presets.order,
                                    direction: statSettings.presets.order.direction || "ASC"
                                }
                                :
                                undefined
                        }
                    />}
                </div>
            </div>
                
        </div>;
    }
}


class StatEditorComponent extends React.Component {

    state = {
        isLoading: false,
    }

    render() {
        if (!this.props.values[this.props.componentConfig.idfield]) {
            return null;
        }
        if (this.state.isLoading) {
            return <ContentLoader />;
        }

        return (
            <Box>
                <div className="row">
                    <div className="col-md-12 stats">
                        <StatisticsTab
                            componentEditor={this.props.componentEditor}
                            values={this.props.values}
                            settings={this.props.values.settings}
                            componentConfig={this.props.componentConfig}
                            setFieldValue={(field, value) => {
                                const values = JSON.parse(JSON.stringify(this.props.values));
                                set(values, "settings." + field, value);
                                this.props.setInitialValues(values);
                                this.props.setFieldValue("settings." + field, value);
                            }}
                        />
                    </div>
                </div>
            </Box>
        );
    }
}

const Editors = {};

export default (props) => {
    if (!props.id) return null;
    props = {...props};
    let Editor;
    if (!Editors[props.id]) {
        Editors[props.id] = Editor = createEditor({
            componentName: "Stat",
            WrappedComponent: StatEditorComponent,
            editor: "Stat" + props.id
        });
    } else {
        Editor = Editors[props.id];
    }
    if (props.setContent) {
        const f = props.setContent;
        props.setContent = (content, props) => f("Stat", props);
    }
    return <Editor {...props} />;
};